import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-error451',
  templateUrl: './error451.component.html',
  styleUrls: ['./error451.component.css'],
})
export class Error451Component implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
